import CreatorPayouts from '../../routes/settings/creator/Payouts'

export default function ProsPayoutsTab() {
  return <CreatorPayouts />
}
